import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class DocumentButtonModel extends ButtonBase {
    label: string = 'Document';
    action: string = ACTION_STATUS.document;
    matIconName: string = 'assignment_ind';
    colorClass: string = 'color-info-500';
}